import { getToken, onMessage, deleteToken } from "firebase/messaging";
import { getFirebaseMessaging } from "./firebase";
import { registerFcmToken, deleteFcmToken } from "api/fcmService";
import { log, LogLevel } from "utils/LogUtil";

const VAPID_KEY = "BFs2jU6rs5FfV08GyRe8Sh5bZ_7OVsoKA3sb1mOpW22h4Ho2p4IlxZJ5UTGj9NyL2rt_bw0JZhl0i_fQKDpAHKw";
const FCM_TOKEN_KEY = "phai_fcmToken";

/** 알림 권한 요청 + FCM 토큰 발급 + 백엔드 등록 */
export const requestAndRegisterFcmToken = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      log(LogLevel.INFO, "알림 권한이 거부되었습니다.");
      return null;
    }

    const messaging = getFirebaseMessaging();
    if (!messaging) {
      log(LogLevel.WARNING, "Firebase Messaging을 사용할 수 없습니다.");
      return null;
    }

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      await registerFcmToken(token, "browser");
      log(LogLevel.INFO, "FCM 토큰 등록 완료");
      localStorage.setItem(FCM_TOKEN_KEY, token);
      return token;
    }

    return null;
  } catch (error) {
    log(LogLevel.ERROR, "FCM 토큰 등록 실패:", error);
    return null;
  }
};

/** FCM 토큰 삭제 (logout thunk에서 호출) */
export const unregisterFcmToken = async (): Promise<void> => {
  try {
    const token = localStorage.getItem(FCM_TOKEN_KEY);
    localStorage.removeItem(FCM_TOKEN_KEY); // 로컬 먼저 정리 (API 실패해도 보장)

    if (token) {
      await deleteFcmToken(token);
      log(LogLevel.INFO, "FCM 토큰 삭제 완료");
    }

    const messaging = getFirebaseMessaging();
    if (messaging) {
      await deleteToken(messaging);
    }
  } catch (error) {
    log(LogLevel.ERROR, "FCM 토큰 삭제 실패:", error);
    // 로그아웃 흐름을 차단하지 않음
  }
};

/** 포그라운드 메시지 리스너 등록 */
export const setupForegroundListener = (
  callback: (payload: any) => void
): (() => void) | null => {
  const messaging = getFirebaseMessaging();
  if (!messaging) return null;

  const unsubscribe = onMessage(messaging, (payload) => {
    log(LogLevel.INFO, "포그라운드 메시지 수신:", payload);
    callback(payload);
  });

  return unsubscribe;
};
